export default __webpack_public_path__ + "static/media/masterCard.567541ae.svg";